import type { FontDefinition } from '../types';

export const CURATED_FONTS: FontDefinition[] = [
  {
    id: 'pacifico',
    name: 'Pacifico',
    family: 'Pacifico',
    category: 'script',
    url: 'https://cdn.jsdelivr.net/gh/google/fonts@main/ofl/pacifico/Pacifico-Regular.ttf',
    designer: 'Vernon Adams',
  },
  {
    id: 'dancing-script',
    name: 'Dancing Script',
    family: 'Dancing Script',
    category: 'script',
    url: 'https://cdn.jsdelivr.net/gh/google/fonts@main/ofl/dancingscript/DancingScript%5Bwght%5D.ttf',
    designer: 'Pablo Impallari',
  },
  {
    id: 'great-vibes',
    name: 'Great Vibes',
    family: 'Great Vibes',
    category: 'script',
    url: 'https://cdn.jsdelivr.net/gh/google/fonts@main/ofl/greatvibes/GreatVibes-Regular.ttf',
    designer: 'TypeSETit',
  },
  {
    id: 'sacramento',
    name: 'Sacramento',
    family: 'Sacramento',
    category: 'script',
    url: 'https://cdn.jsdelivr.net/gh/google/fonts@main/ofl/sacramento/Sacramento-Regular.ttf',
    designer: 'Astigmatic',
  },
  {
    id: 'caveat',
    name: 'Caveat',
    family: 'Caveat',
    category: 'script',
    url: 'https://cdn.jsdelivr.net/gh/google/fonts@main/ofl/caveat/Caveat%5Bwght%5D.ttf',
    designer: 'Pablo Impallari',
  },
  {
    id: 'satisfy',
    name: 'Satisfy',
    family: 'Satisfy',
    category: 'script',
    url: 'https://cdn.jsdelivr.net/gh/google/fonts@main/apache/satisfy/Satisfy-Regular.ttf',
    designer: 'Sideshow',
  },
  {
    id: 'alex-brush',
    name: 'Alex Brush',
    family: 'Alex Brush',
    category: 'script',
    url: 'https://cdn.jsdelivr.net/gh/google/fonts@main/ofl/alexbrush/AlexBrush-Regular.ttf',
    designer: 'TypeSETit',
  },
  {
    id: 'cookie',
    name: 'Cookie',
    family: 'Cookie',
    category: 'script',
    url: 'https://cdn.jsdelivr.net/gh/google/fonts@main/ofl/cookie/Cookie-Regular.ttf',
    designer: 'Ania Kruk',
  },
  {
    id: 'parisienne',
    name: 'Parisienne',
    family: 'Parisienne',
    category: 'script',
    url: 'https://cdn.jsdelivr.net/gh/google/fonts@main/ofl/parisienne/Parisienne-Regular.ttf',
    designer: 'Astigmatic',
  },
  {
    id: 'allura',
    name: 'Allura',
    family: 'Allura',
    category: 'script',
    url: 'https://cdn.jsdelivr.net/gh/google/fonts@main/ofl/allura/Allura-Regular.ttf',
    designer: 'TypeSETit',
  },
  {
    id: 'lobster',
    name: 'Lobster',
    family: 'Lobster',
    category: 'display',
    url: 'https://cdn.jsdelivr.net/gh/google/fonts@main/ofl/lobster/Lobster-Regular.ttf',
    designer: 'Impallari Type',
  },
  {
    id: 'montserrat',
    name: 'Montserrat',
    family: 'Montserrat',
    category: 'sans',
    url: 'https://cdn.jsdelivr.net/gh/google/fonts@main/ofl/montserrat/Montserrat%5Bwght%5D.ttf',
    designer: 'Julieta Ulanovsky',
  },
  {
    id: 'bebas-neue',
    name: 'Bebas Neue',
    family: 'Bebas Neue',
    category: 'display',
    url: 'https://cdn.jsdelivr.net/gh/google/fonts@main/ofl/bebasneue/BebasNeue-Regular.ttf',
    designer: 'Ryoichi Tsunekawa',
  },
  {
    id: 'oswald',
    name: 'Oswald',
    family: 'Oswald',
    category: 'sans',
    url: 'https://cdn.jsdelivr.net/gh/google/fonts@main/ofl/oswald/Oswald%5Bwght%5D.ttf',
    designer: 'Vernon Adams',
  },
  {
    id: 'playfair-display',
    name: 'Playfair Display',
    family: 'Playfair Display',
    category: 'serif',
    url: 'https://cdn.jsdelivr.net/gh/google/fonts@main/ofl/playfairdisplay/PlayfairDisplay%5Bwght%5D.ttf',
    designer: 'Claus Eggers Sørensen',
  },
  {
    id: 'cinzel',
    name: 'Cinzel Decorative',
    family: 'Cinzel Decorative',
    category: 'serif',
    url: 'https://cdn.jsdelivr.net/gh/google/fonts@main/ofl/cinzeldecorative/CinzelDecorative-Bold.ttf',
    designer: 'Natanael Gama',
  },
  {
    id: 'abril-fatface',
    name: 'Abril Fatface',
    family: 'Abril Fatface',
    category: 'display',
    url: 'https://cdn.jsdelivr.net/gh/google/fonts@main/ofl/abrilfatface/AbrilFatface-Regular.ttf',
    designer: 'TypeTogether',
  },
  {
    id: 'righteous',
    name: 'Righteous',
    family: 'Righteous',
    category: 'display',
    url: 'https://cdn.jsdelivr.net/gh/google/fonts@main/ofl/righteous/Righteous-Regular.ttf',
    designer: 'Astigmatic',
  },
  {
    id: 'caveat-brush',
    name: 'Caveat Brush',
    family: 'Caveat Brush',
    category: 'script',
    url: 'https://cdn.jsdelivr.net/gh/google/fonts@main/ofl/caveatbrush/CaveatBrush-Regular.ttf',
    designer: 'Pablo Impallari',
  },
];

export const DEFAULT_FONT_ID = 'pacifico';
